<template>
    <!-- <tr v-show="false first"></tr> -->
    <tr :class="{active: is_running, missing: !missingStartTime}">
        <td style="font-weight:bold;" :style="{'borderTop': borderTop}">{{ dateRowShown }}</td>

        <td :style="{'borderTop': borderTop}">{{ name }}</td>

        <td :style="{'borderTop': borderTop}">{{ startTime }}</td>

        <td v-if="!plain" :style="{'borderTop': borderTop}">{{ startElectronicDevice }}</td>

        <td :style="{'borderTop': borderTop}">{{ stopDate }}</td>

        <td :style="{'borderTop': borderTop}">{{ stopTime }}</td>

        <!-- <td :style="{'borderTop': borderTop}">
          <v-checkbox
            hide-details
            class="ma-0 pa-0"
            color="#0F998E"
            disabled
            v-model="activatedPause"
            label=""
          ></v-checkbox>
        </td> -->

        <td v-if="!plain" :style="{'borderTop': borderTop}">{{ stopElectronicDevice }}</td>

        <td :style="{'borderTop': borderTop}">{{ startExchange }}</td>

        <!-- <td>{{ price | price}}</td> -->
        <td :style="{'borderTop': borderTop}">{{ stopExchange }}</td>

        <td :style="{'borderTop': borderTop}">{{ difference }}</td>

        <td v-if="!plain" :style="{'borderTop': borderTop}">{{ cash }}</td>

        <td v-if="!plain" :style="{'borderTop': borderTop}">{{ card }}</td>

        <td v-if="!plain" :style="{'borderTop': borderTop}">{{ cleared_orders }}</td>

        <td class="text-left" :style="{'borderTop': borderTop}">{{ totalTime }}</td>

        <td v-if="!plain" class="text-right" style="display: flex; flex-direction: row; align-items: center;" :style="{'borderTop': borderTop}">
          <ButtonActionEdit @click="$emit('emitForm', { user: name, start_id, stop_id, startExchange, stopExchange, startDate, stopDate, startTime, stopTime, yesterday, tomorrow, lastSessionData, nextSessionData })" />
          <ButtonActionDelete @click="showDeleteArticleModal = true; deleteArticle = article" />
        </td>

        <ConfirmDialog
          title="Brisanje vnosa"
          text="Ali ste prepričani, da želite izbrisati vnos? Podatki bodo trajno izbrisani."
          okBtnText="Briši"
          v-model="showDeleteArticleModal"
          @confirmed="remove(deleteArticle)"
        />
    </tr>
</template>

<script>
import { mapActions } from 'vuex'
import ButtonActionSave from '@/components/ButtonActionSave'
import ButtonActionCloseEditing from '@/components/ButtonActionCloseEditing'
import ButtonActionEdit from '@/components/ButtonActionEdit'
import ConfirmDialog from '@/components/ConfirmDialog'
import ButtonActionDelete from '@/components/ButtonActionDelete'
import moment from 'moment'

export default {
  components: {
    ButtonActionSave,
    ConfirmDialog,
    ButtonActionEdit,
    ButtonActionCloseEditing,
    ButtonActionDelete
  },
  props: {
    dayData: {
      type: Object
    },
    plain: {
      type: Boolean,
      default: false,
    }
  },
  data () {
    return {
      activatedPause: null,
      yesterday: null,
      tomorrow: null,
      lastSessionData: null,
      nextSessionData: null,
      showDeleteArticleModal: false,
      id: null,
      start_id: null,
      stop_id: null,
      first: null,
      is_running: false,
      name: '',
      card: 0,
      cash: 0,
      difference: 0,
      startExchange: 0,
      startDate: '',
      startTime: '',
      startElectronicDevice: '',
      stopExchange: 0,
      stopDate: '',
      stopElectronicDevice: '',
      cleared_orders: 0,
      totalTime: '',
      stopTime: '',
      missingStartTime: false
    }
  },
  computed: {
    isFirst () {
      return this.first
    },
    dateRowShown () {
      return !this.isFirst ? '' : this.startDate
      // return this.startDate
    },
    borderTop () {
      return !this.isFirst || !this.missingStartTime ? '' : '1px solid #000'
    }
  },
  methods: {
    ...mapActions('delovnicas', { deleteItem: 'removeUserWorkTime' }),
    async remove (item) {
      if (this.start_id) await this.deleteItem(this.start_id)
      if (this.stop_id) await this.deleteItem(this.stop_id)
      this.$emit('refresh')
    },
    setCurrentRowData () {
      // console.log(this.dayData.start_time.split('T'))
      this.id = this.dayData.id
      this.yesterday = this.dayData.yesterday
      this.tomorrow = this.dayData.tomorrow
      this.lastSessionData = this.dayData.lastSessionData
      this.nextSessionData = this.dayData.nextSessionData
      this.start_id = this.dayData.start_id
      this.stop_id = this.dayData.stop_id
      var [sDate, sTime] = this.dayData.start_time && this.dayData.start_time.split('T') || [null,null]
      var [eDate, eTime] = this.dayData.stop_time && this.dayData.stop_time.split('T') || [null,null]
      this.first = this.dayData.first
      this.is_running = this.dayData.is_running
      this.name = this.dayData.name
      this.card = this.dayData.card_payments
      this.cash = this.dayData.cash_payments
      this.difference = this.dayData.cash_difference
      this.startExchange = this.dayData.start_exchange
      this.startDate = sDate ? moment(sDate).format('DD.MM.YYYY') : ''
      this.startTime = sTime
      this.startElectronicDevice = this.dayData.electronic_device_id_start
      this.stopExchange = this.dayData.stop_exchange
      this.stopDate = eDate ? moment(eDate).format('DD.MM.YYYY') : ''
      this.stopElectronicDevice = this.dayData.electronic_device_id_stop
      this.cleared_orders = this.dayData.cleared_orders
      this.totalTime = `${this.dayData.hours}:${this.dayData.minutes}`
      this.stopTime = eTime
      this.missingStartTime = this.dayData.missingStartTime
    }
  },
  mounted () {
    // console.log(this.dayData)
    this.setCurrentRowData()
  }
}
</script>

<style scoped lang="scss">
  .active {
    background-color: #bfffbf !important;
  }
  .missing {
    // background-color: rgb(222, 120, 114) !important;
    color: red;
  }
</style>
